//Import
import * as Menu from './menu';
import * as Faq from './faq';
import * as Testimonials from './testimonials';
import * as Parallax from'./parallax';
import * as Carousel from './carousel';
import * as Modals from'./modals';
import * as Lojas from './lojas';
import * as Login from './login';

(()=>{
	'use strict';

	if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
		$('body').addClass('is-safari');
	}

	$('a[data-change-method').on('click', function(e) {
		e.preventDefault();

		$('.button-icon-round').removeClass('button-icon-round-active');

		$('['+ $(this).attr('data-change-method') +']').addClass('button-icon-round-active');

		if($(this).attr('data-change-method') == 'button-mobile') {
			$('[method-placeholder]').attr('placeholder', 'Digite seu número');
			$('input').hide();
			$('input[type="tel"]').show();
		} else {
			$('[method-placeholder]').attr('placeholder', 'Digite seu email')
			$('input').hide();
			$('input[type="text"]').show();
		}
	})
})();


//disable zoom on iOS > 10
document.addEventListener('touchmove', function (event) {
  if (event.scale !== 1) { event.preventDefault(); }
}, false);
